import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import paylocityPayrollComponent from './paylocity-payroll.component';
import paylocityPayrollDetailsComponent from './paylocity-payroll-details.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let paylocityPayrollModule = angular.module('paylocityPayroll', [
  uiRouter,
  modal,
  datepickerPopup,
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider.state('paylocity-payroll', {
    parent: 'app',
    url: '/admin/integrations/paylocity/payroll',
    data: {
      pageHeader: true,
      pageTitle: 'Paylocity Payroll Information',
      pageDesc: '',
      breadcrumbLink: 'paylocity',
      breadcrumbText: 'Paylocity Capabilities'
    },
    template: '<paylocity-payroll></paylocity-payroll>'
  });

  $stateProvider.state('paylocity-payroll-details', {
    parent: 'app',
    url: '/admin/integrations/paylocity/payroll/:checkDate',
    data: {
      pageHeader: false,
      pageTitle: 'Payroll check details',
      pageDesc: '',
      breadcrumbLink: 'paylocity-payroll',
      breadcrumbText: 'Payroll'
    },
    template: '<paylocity-payroll-details></paylocity-payroll-details>'
  });

})

.component('paylocityPayroll', paylocityPayrollComponent)
.component('paylocityPayrollDetails', paylocityPayrollDetailsComponent);

export default paylocityPayrollModule;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/paylocity/capabilities/payroll/paylocity-payroll.js